import React from 'react';
import { AzdevopsPage } from '@dewise-devex/backstage-plugin-azdevops';
import { MeeweeTimeRegistrationPage } from '@dewise-devex/backstage-plugin-meewee-time-registration';
import { Grid } from '@dewise-devex/backstage-plugin-mui-uikit-react';

export const TasksAndRegistrations = () => {
  return (
    <>
      <Grid size={{ sm: 12, xs: 12, md: 5 }}>
        <MeeweeTimeRegistrationPage />
      </Grid>
      <Grid size={{ sm: 12, xs: 12, md: 7 }}>
        <AzdevopsPage />
      </Grid>
    </>
  );
};
